import { guestAccessPath, type AssessmentId } from "@thalamos/haven-common";

/**
 * Path builders for a guest's pages. All sit under `guestAccessPath`,
 * outside every staff page, so a guest session never renders one.
 */
export const guestRoute = {
  /** Where an emailed link lands; its token follows in the fragment. */
  signIn: () => guestAccessPath,
  assessment: () => `${guestAccessPath}/assessment`,
  assessmentDomain: (group: string) =>
    `${guestAccessPath}/assessment/domains/${encodeURIComponent(group)}`,
  assessmentItem: (group: string, item: string) =>
    `${guestAccessPath}/assessment/domains/${encodeURIComponent(group)}/${encodeURIComponent(item)}`,
  /** The thank-you page, once the assessment is sent. */
  sent: () => `${guestAccessPath}/sent`,
  /** The assessments shared with the guest. */
  shared: () => `${guestAccessPath}/shared`,
  sharedAssessment: (assessmentId: AssessmentId) =>
    `${guestAccessPath}/shared/${encodeURIComponent(assessmentId)}`,
};
